import { apiUrl } from "./util";

const ping = () => {
  console.log("PING");
  // create a new XMLHttpRequest
  var xhr = new XMLHttpRequest();

  // get a callback when the server responds
  xhr.addEventListener("load", () => {
    console.log(xhr.responseText);
  });
  // open the request with the verb and the url
  xhr.open("GET", apiUrl + "/ping?" + new Date().getTime());
  // send the request
  xhr.send();
};
export default ping;
